import React, { useEffect, useState } from 'react';
import { StatCard } from './charts/StatCard';
import { BarChart } from './charts/BarChart';
import { PieChart } from './charts/PieChart';
import { AdminDataService } from '../services/AdminDataService';
import { GameAnalyticsData } from '../types';
import './GameAnalytics.css';

export const GameAnalytics: React.FC = () => {
  const [data, setData] = useState<GameAnalyticsData | null>(null);

  useEffect(() => {
    const dataService = AdminDataService.getInstance();
    setData(dataService.getGameAnalytics());
  }, []);

  if (!data) return null;

  const formatDuration = (seconds: number): string => {
    if (seconds < 60) return `${seconds}s`;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
  };

  return (
    <div className="admin-analytics">
      <h2 className="admin-analytics__title">Game Analytics</h2>

      <div className="admin-analytics__stats-grid">
        <StatCard
          icon="🎮"
          label="Total Games"
          value={data.totalGamesPlayed}
          variant="blue"
        />
        <StatCard
          icon="⏱️"
          label="Avg Duration"
          value={formatDuration(data.avgDuration)}
          variant="green"
        />
        <StatCard
          icon="🏆"
          label="Most Popular"
          value={data.mostPopular}
          variant="purple"
        />
      </div>

      <div className="admin-analytics__charts">
        {data.playCountPerGame.length > 0 && (
          <BarChart
            data={data.playCountPerGame}
            title="Play Count per Game"
          />
        )}
        <PieChart
          data={data.modeDistribution}
          title="Game Mode Distribution"
        />
      </div>
    </div>
  );
};
